import { mainFetch } from "../mainFetch";

const SERVICE_URL = '/shipment/supply'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class SuppliesApi {

    static async createSupply({ data = { market: undefined, shop: undefined, time_scheduled: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/create', method: 'POST', data, notify: { msg: 'Поставка создана' }, ...params })
    }

    static async getSupplies({ data = { market: undefined, shipmentDate: undefined, status: undefined, limit: undefined, page: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/getsupplies', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async changeSupply({ data = { supplyId: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changesupply', method: 'PATCH', data, ...params })
    }

    static async changeSupplies({ data = { supplyId: undefined, action: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changesupplies', method: 'PATCH', data, ...params })
    }

    static async deleteSupply({ data = { supplyId: undefined }, ...params }) {
        return await fetchService({ url: '/deletesupply', method: 'DELETE', data, notify: { msg: 'Поставка удалена' }, ...params })
    }

    static async getSupplyItems({ data = { supplyId: undefined }, ...params }) {
        return await fetchService({ url: '/getsupplyitems', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getSupplyItemsStat({ data = { supplyId: undefined }, ...params }) {
        return await fetchService({ url: '/getsupplyitemsstat', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getSupplyItemsDays({ data = { supplyId: undefined }, ...params }) {
        return await fetchService({ url: '/getsupplyitemsdays', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getCards({ data = { shop: undefined, providerId: undefined, search: undefined }, ...params }) {
        return await fetchService({ url: '/getcards', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async changeProductsInSupply({ data = { shop: undefined, providerId: undefined, search: undefined }, ...params }) {
        return await fetchService({ url: '/changeproductsinsupply', method: 'PATCH', data, ...params })
    }

    static async changeSupplyBox({ data = { shop: undefined, providerId: undefined, search: undefined }, ...params }) {
        return await fetchService({ url: '/changesupplybox', method: 'PATCH', data, ...params })
    }

    static async boxSticker({ data = { offerId: undefined, shop: undefined }, ...params }) {
        return await fetchService({ url: '/boxsticker', method: 'POST', data, options: { pdf: true }, ...params })
    }

    static async boxWbStickers({ data = { offerId: undefined, shop: undefined }, ...params }) {
        return await fetchService({ url: '/boxwbstickers', method: 'POST', data, options: { pdf: true }, ...params })
    }

    static async excelBoxes({ data = { suplyId: undefined }, ...params }) {
        return await fetchService({ url: '/excelboxes', method: 'POST', data, options: { download: true }, notify: { success: false }, ...params })
    }

    static async excelAnalitic({ data = { suplyId: undefined }, ...params }) {
        return await fetchService({ url: '/excelanalitic', method: 'POST', data, options: { download: true }, notify: { success: false }, ...params })
    }

    static async debitWarehouse({ data = { suplyId: undefined }, ...params }) {
        return await fetchService({ url: '/debitfromwarehouse', method: 'POST', data, ...params })
    }


    static async getWarehouses({ data = {}, ...params }) {
        return await fetchService({ url: '/getwarehouses', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async checkSupplyList({ data = {}, ...params }) {
        return await fetchService({ url: '/checksupplylist', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async excelTemplateToCheck({ data = {}, ...params }) {
        return await fetchService({ url: '/exceltemplatetocheck', method: 'POST', data, options: { download: true }, notify: { success: false }, ...params })
    }


    static async excelTemplatePurchase({ data = {}, ...params }) {
        return await fetchService({ url: '/exceltemplatepurchase', method: 'POST', data, options: { download: true }, notify: { success: false }, ...params })
    }

    static async updatePrices({ data = { supplyId: undefined }, ...params }) {
        return await fetchService({ url: '/updateprices', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getStorageWb({ data = { shop: undefined, search: undefined, tab: undefined, providerId: undefined, filters: undefined, limit: undefined, page: undefined }, ...params }) {
        return await fetchService({ url: '/getstoragewb', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async saveTariff({ data = {}, ...params }) {
        return await fetchService({ url: '/savetariff', method: 'POST', data, notify: { success: true }, ...params })
    }

    static async excelStorageWb({ data = { shop: undefined, search: undefined, tab: undefined, filters: undefined, providerId: undefined }, ...params }) {
        return await fetchService({ url: '/excelstoragewb', method: 'POST', data, options: { download: true }, ...params })
    }

    static async savePurchase({ data = {}, ...params }) {
        return await fetchService({ url: '/savepurchase', method: 'POST', data, notify: { success: true }, ...params })
    }

    static async getPackagingProductsFbo({ data = {}, ...params }) {
        return await fetchService({ url: '/getpackagingproductsfbo', method: 'POST', data, notify: { success: false }, ...params })
    }

      static async updateWorkCost({ data = {}, ...params }) {
        return await fetchService({ url: '/updateworkcost', method: 'POST', data,  ...params })
    }

    
}